import { FormFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import AfterSalesExchangeGood from './AfterSalesExchangeGood.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.ManyToMany,
    widget: 'AfterSalesExchangeGood',
    multi: true
  })
)
export class DetailM2mMultiAfterSalesExchangeGoodFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(AfterSalesExchangeGood);
    return this;
  }
}